import template from './settings.html';
import controller from './settings.controller';

let settingsComponent = {
    template: template,
    controller: controller,
    controllerAs: 'settingsCtrl'
  };

export default settingsComponent;
